







































import { defineComponent } from '@vue/composition-api';
import OlbIcon from '../../icon';
import { Page } from '../types';

export default defineComponent({
	components: {
		OlbIcon,
	},
	props: {
		url: {
			type: String,
		},
		prevPage: {
			type: String,
		},
		nextPage: {
			type: String,
		},
		prevIsDisabled: {
			type: Boolean,
		},
		nextIsDisabled: {
			type: Boolean,
		},
		pages: {
			type: Array as () => Page[],
		},
	},
});
